import {Component, OnInit} from '@angular/core';
import {GroupsService} from './groups.service';
import {Group} from '../../model/group';
import {GroupsPagerService} from './groups-pager.service';
import {NotifierService} from '../notifier/notifier.service';
import {NotificationType} from '../notifier/notification-type.enum';
import {BlockadeType} from './blockade-type.enum';
import {User} from '../../model/user';
import {Set} from '../../model/set';
import {CreateGroupStep} from '../group-create/create-group-step.enum';
import {forkJoin} from 'rxjs/observable/forkJoin';
import {GroupStatus} from './group-status.enum';
import {GroupNotifications} from './group-notifications.enum';
import {FormMode} from '../group-create/form-mode.enum';
import {GroupCreateService} from '../group-create/group-create.service';
import { NgbDateStruct, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {CommonService} from "../../common/common.service";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: 'pbc-groups',
  templateUrl: './groups.component.html',
  styleUrls: [ './groups.component.css']
})
export class GroupsComponent implements OnInit {

  private groups: Array<Group> = [];
  groupsSelected : Array<number> = [];
  allGroupsMarked : boolean;
  private filteredGroupsCounter : number = this.groups.length;  
  private groupForOperations : Group;
  private usersFromGroup: Array<User> = [];
  private usersFromGroupShowHide: Array<string> = [];

  private createEditGroupStep : CreateGroupStep = undefined;
  private createEditGroupMode : FormMode = undefined;

  //Filtry
  showFilterPopup : boolean = false;
  groupsAreFiltered : boolean = false;
  private domainsForFilter : Array<string> = [];
  private domainsForFilterSelected : Array<string> = [];
  private domainsIdsForFilterSeleted : Array<string> = [];
  private setsForFilter : Array<Set> = [];
  private setsIdsForFilterSelected : Array<number> = [];
  private groupStatusForFilterSelected : Array<GroupStatus> = [];
  private notificationsForFilterSelected : Array<GroupNotifications> = [];

  //Sortowania
  orderByField : string = "name";
  orderAsc : boolean =  true;

  groupStatusEnum = GroupStatus;
  groupNotificationEnum = GroupNotifications;
  formModeEnum = FormMode;

  private readonly MORE_LESS_LIMIT : number = 5;

  blockadeType : BlockadeType = BlockadeType.tillCancelation;
  private blockedTill : any = null;

  showConfirmRemoveGroupPopup: boolean = false;
  showUnblockGroupPopup : boolean = false;
  showBlockGroupPopup : boolean = false;
  showBlockGroupTillCalendar : boolean = false;
  showRemoveUsersFromGroupPopup : boolean = false;

  private blockadeTypeEnum = BlockadeType;
  private currentPage : number = 1;
  public minDate: any;

  constructor(
    private groupsService: GroupsService,
    private pagerService: GroupsPagerService,
    private notifierService : NotifierService,
    private groupCreateService : GroupCreateService,
    private config: NgbDatepickerConfig,
    private breadCrumbsService : BreadcumbsService,
    private commonService : CommonService,
    private activatedRoute : ActivatedRoute
  ) { 
    let current = new Date();
    config.minDate = { year: current.getFullYear(), month: current.getMonth() + 1, day: current.getDate() };
    config.outsideDays = 'hidden';

  }

  pager: any = new Object();
  pagedGroups: Array<Group>;
  private static pageSize: number = 20;
  pageLimit: number = 100;

  ngOnInit() {
    this.getGroups();
    setTimeout(()=>this.breadCrumbsService.setSubfolder.emit("Grupy"),100);

    this.groupCreateService.groupAddedOrModified.subscribe((result : boolean)=>{
      if (result)
        this.getGroups(this.currentPage);
    })

    this.activatedRoute.params.subscribe(
      queryParams => {
        const refresh = queryParams['refresh'];
        if (refresh > 0)
          this.onResetFilterForm();
      }
    )
  }

  setPage(page: number) {
    this.pager = this.pagerService.getPager(this.groups.length, page, GroupsComponent.pageSize);
    this.currentPage = page;
    this.pagedGroups = this.groups.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    )
  }

  orderByClick(orderByField : string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }
    if (!this.groupsAreFiltered)
      this.getGroups();
    else
      this.getFilteredGroups(true);
  }

  selectAllGroups(): void {

    this.allGroupsMarked = !this.allGroupsMarked;

    for (let set of this.groups) {
      let groupPosition = this.groupsSelected.indexOf(set.id);

      if (this.allGroupsMarked && groupPosition === -1)
        this.groupsSelected.push(set.id);

      if (!this.allGroupsMarked && groupPosition !== -1)
        this.groupsSelected.splice(groupPosition, 1);
    }
  }

  private modifyGroupsSelected(groupId: number): void {
    let idPosition = this.groupsSelected.indexOf(groupId);

    if (idPosition === -1) {
      this.groupsSelected.push(groupId);
    } else {
      this.groupsSelected.splice(idPosition, 1);
    }

    if (this.groupsSelected.length === this.groups.length)
      this.allGroupsMarked = true;
    else
      this.allGroupsMarked = false;
  }

  private createSortString() : string {
    let sortString = '';
    if (this.orderAsc)
      sortString = this.orderByField.concat(" ASC");
    else
      sortString = this.orderByField.concat(" DESC");

    return sortString
  }

  private getGroups(goOnPage?:number) : void {


    this.commonService.getGroupList(this.createSortString()).subscribe(
      data => {
        if (data.status != 'OK') {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano listy grup");
        } else {
          this.groups = data.record;
          this.filteredGroupsCounter = this.groups.length;
          if (goOnPage>1)
            this.setPage(goOnPage);
          else
            this.setPage(1);
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania listy grup");
      }
    )
  }

  private deleteGroups() : void {
    this.groupsService.deleteGroups(this.groupsSelected).subscribe(
      response => {
        if (response.status != 1) {
          if (this.groupsSelected.length > 0)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Zaznaczone grupy użytkowników nie zostały usunięte. Spróbuj jeszcze raz.");
          else
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Zaznaczona grupy użytkowników nie została usunięte. Spróbuj jeszcze raz.");
        } else {
          if (this.groupsSelected.length>1)
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
              "Grupy (".concat(this.groupsSelected.length.toString(), " ) zostały poprawnie usunięte"));
          else
            this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
              "Grupa ".concat(response.record[0].name, " poprawnie usunięta"));

          this.groupsSelected = [];
          this.getGroups(this.currentPage);
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Zaznaczone grupy użytkowników nie zostały usunięte. Spróbuj jeszcze raz.");
      }
    );

    this.closeConfirmRemoveGroup();
  }

  private unblockGroup() {
    this.groupsService.unBlockGroup(this.groupForOperations.id).subscribe(
      response => {
        if (response.status !=1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Grupa ".concat(this.groupForOperations.name, "nie została odblokowana. Spróbuj jeszcze raz."));
        } else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Grupa ".concat(this.groupForOperations.name ," została odblokowana"));
          this.getGroups(this.currentPage);
        }
        this.closeUnblockGroup();
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Grupa ".concat(this.groupForOperations.name, "nie została odblokowana. Spróbuj jeszcze raz."));
        this.closeUnblockGroup();
      }
    );
  }

  private blockGroup() {
    let blockedTillDate = undefined;
    if (this.blockedTill) {
      blockedTillDate = new Date(this.blockedTill.year, this.blockedTill.month-1, this.blockedTill.day);
    }
    this.groupsService.blockGroup(this.groupForOperations.id, blockedTillDate).subscribe(
      response => {
        if (response.status !=1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Grupa ".concat(this.groupForOperations.name, "nie została zablokowana. Spróbuj jeszcze raz."));
        } else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Grupa ".concat(this.groupForOperations.name ," została zablokowana"));
          this.getGroups(this.currentPage);
        }
        this.closeBlockGroup();
      },
      error=> {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd! Grupa ".concat(this.groupForOperations.name, "nie została zablokowana. Spróbuj jeszcze raz."));
        this.closeBlockGroup();
      }
    );
  }

  private removeUserFromGroup(user : User) {
    let usersIdsToRemove = Array<number>();

    this.usersFromGroup.splice(this.usersFromGroup.indexOf(user), 1);

    usersIdsToRemove.push(user.id);

    this.groupsService.removeUserFromGroup(this.groupForOperations.id, usersIdsToRemove).subscribe(
      response => {
        if (response.status != 1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd! Użytkownik ".concat(user.firstName, " ", user.lastName, " nie został usunięty z grupy ",
              this.groupForOperations.name,  ". Spróbuj jeszcze raz."));
        } else {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Użytkownik ".concat(user.firstName, " ", user.lastName, " został usunięty z grupy ", this.groupForOperations.name));
          this.getGroups(this.currentPage);
        }
      },
      error => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Bład w trakcie usuwania użytkownika z grupy");
      }
    );
  }

  private onChangeBlockadeType() {
    switch (this.blockadeType) {
      case BlockadeType.tillCancelation : {
        this.showBlockGroupTillCalendar = false;
        this.blockedTill = undefined;
        break;
      }
      case BlockadeType.tillDate : {
        this.showBlockGroupTillCalendar = true;
        break;
      }
    }
  }

  showConfirmRemoveGroup() {
    this.showConfirmRemoveGroupPopup = true;
  }

  private closeConfirmRemoveGroup() {
    this.showConfirmRemoveGroupPopup = false;
  }

  private showUnblockGroup(groupForUnblock : Group) {
    this.groupForOperations = groupForUnblock;
    this.showUnblockGroupPopup = true;
  }

  private closeUnblockGroup() {
    this.groupForOperations = null;
    this.showUnblockGroupPopup = false;
  }

  private showBlockGroup(groupForBlock : Group) {
    this.groupForOperations = groupForBlock;
    this.showBlockGroupPopup = true;
    this.resetBlockadeForm();
  }

  private resetBlockadeForm() {
    this.blockadeType = BlockadeType.tillCancelation;
    this.blockedTill = "";
    this.showBlockGroupTillCalendar = false;
  }

  private closeBlockGroup() {
    this.groupForOperations = null;
    this.showBlockGroupPopup = false;
    this.resetBlockadeForm();
  }

  private showRemoveUsersFromGroup(groupForUsers : Group) {
    this.groupForOperations = groupForUsers;
    this.groupsService.getGroup(groupForUsers.id).subscribe(
      response => {
        if (response.status !=1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano danych grupy");
        } else {
          this.usersFromGroup = response.record[0].users;
          this.showRemoveUsersFromGroupPopup = true;
          this.usersFromGroupShowHide = [];
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania danych grupy")
      }
    );
  }

  private showConfirmForUserRemove(userId: string) {
    let userPosition = this.usersFromGroupShowHide.indexOf(userId);
    if (userPosition == -1)
      this.usersFromGroupShowHide.push(userId);
    else
      this.usersFromGroupShowHide.splice(userPosition, 1);
  }

  private closeRemoveUsersFromGroup() {
    this.showRemoveUsersFromGroupPopup = false;
    this.usersFromGroupShowHide = [];
  }

  showCreateGroup() {
      this.groupCreateService.showForm(FormMode.CREATE, CreateGroupStep.Definition);
  }

  private showEditGroup(group : Group) {
      this.groupCreateService.showForm(FormMode.EDIT, CreateGroupStep.Definition, group);
  }

  showFilterForm() {
    forkJoin(
      this.groupsService.getDomainsForFilter(),
      this.groupsService.getSetList()
    ).subscribe(([domainsResult, setsResult])=>{

      if (domainsResult.status != 1) {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Nie pobrano listy domen")
      } else {
        this.domainsForFilter = domainsResult.record;
      }

      if (setsResult.status != 1) {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Nie pobrano listy zestawów")
      } else {
        this.setsForFilter = [];
        setsResult.record.forEach((set : Set) => {
          if (set.groups.length > 0)
            this.setsForFilter.push(set);
        });
      }

    });

    this.showFilterPopup = true;
  }

  private closeFilterForm() {
    this.showFilterPopup = false;
    if (!this.groupsAreFiltered)
      this.resetFilterForm();
  }

  private resetFilterForm() {
    this.groupStatusForFilterSelected = [];
    this.notificationsForFilterSelected = [];
    this.domainsForFilterSelected = [];
    this.setsIdsForFilterSelected = [];
    this.domainsIdsForFilterSeleted = [];
  }

  private onResetFilterForm() {
    this.groupsAreFiltered = false;
    this.closeFilterForm();
    this.getFilteredGroups(true);
  };

  private modifyDomainsForFilterSelected(domainName: string) {
    let domainPosition = this.domainsForFilterSelected.indexOf(domainName);
    if (domainPosition == -1) {
      this.domainsForFilterSelected.push(domainName);
    } else {
      this.domainsForFilterSelected.splice(domainPosition,1);
    }

    this.getFilteredGroups(false);
  }

  private modifySetsForFilterSelected(set : Set) {
    let setPosition = this.setsIdsForFilterSelected.indexOf(set.id);
    if (setPosition == -1) {
      this.setsIdsForFilterSelected.push(set.id);
    } else {
      this.setsIdsForFilterSelected.splice(setPosition, 1);
    }

    this.getFilteredGroups(false);
  }

  private modifyGroupStatusForFilterSelected (status : GroupStatus) {
    let statusPosition = this.groupStatusForFilterSelected.indexOf(status);
    if (statusPosition == -1) {
      this.groupStatusForFilterSelected.push(status)
    } else {
      this.groupStatusForFilterSelected.splice(statusPosition, 1);
    }

    this.getFilteredGroups(false);
  }

  private modifyNotificationsForFilterSelected(notification : GroupNotifications) {
    let notificationPosition = this.notificationsForFilterSelected.indexOf(notification);
    if (notificationPosition == -1) {
      this.notificationsForFilterSelected.push(notification)
    } else {
      this.notificationsForFilterSelected.splice(notificationPosition, 1);
    }

    this.getFilteredGroups(false);
  }

  private getFilteredGroups(returnResult : boolean) {

    let filterCriteria = {};
    filterCriteria['sortString']= this.createSortString();

    if (this.groupStatusForFilterSelected.length === 1) {
      if (this.groupStatusForFilterSelected[0] == GroupStatus.unblocked)
        filterCriteria['blockedFilter'] = false;
      else
        filterCriteria['blockedFilter'] = true;
    }

    if (this.notificationsForFilterSelected.length === 1) {
      if (this.notificationsForFilterSelected[0] == GroupNotifications.send)
        filterCriteria['sendNotification'] = true;
      else
        filterCriteria['sendNotification'] = false;
    }

    if (this.setsIdsForFilterSelected.length)
      filterCriteria['sets'] = this.setsIdsForFilterSelected;

    if (this.domainsForFilterSelected.length > 0) {
      this.groupsService.getDomainIdsByDomainNames(this.domainsForFilterSelected).subscribe(
        response => {
          if (response.status != 1) {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie można pobrać danych domen");
          } else {
            this.domainsIdsForFilterSeleted = response.record;
            filterCriteria['safedomains'] = this.domainsIdsForFilterSeleted;
            this.getFilteredGroupsFromService(filterCriteria, returnResult);
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania danych domen");
        }
      )
    } else {
      this.getFilteredGroupsFromService(filterCriteria, returnResult);
    }
  }

  private getFilteredGroupsFromService(filterCriteria : any, returnResult : boolean) {

    this.groupsService.getFilteredGroupList(filterCriteria).subscribe(
      response=>{
        if (response.status !== 'OK') {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano listy grup");
        } else {
          this.filteredGroupsCounter = response.record.length;
          if (returnResult) {
            this.groups = response.record;
            this.setPage(this.currentPage);
          }
        }
      },
      error=>{
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: w trakcie pobierania listy grup");
      });
  }

  private showFilteredGroups() {
    this.getFilteredGroups(true);
    this.groupsAreFiltered = true;
    this.groupsSelected = [];
    this.allGroupsMarked = false;
    this.closeFilterForm();
  }

  private getGroup(id : number) {
    this.groupsService.getGroup(id).subscribe(
      response => {
        if (response.status !== 1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Bład: Nie pobrano danych grupy");
        } else {

        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania danych grupy");
      }
    )
  }

  setPages(param: any) {
    //co tu ma się robić?
  }
}
